const { getDateInstance } = require('./getDateInstance')

const { consts } = require('./consts')

/**
 * Visszaadja, hogy két dátum között mennyi nap van.
 * @param {string | number | Date} start - A kezdődátum.
 * @param {string | number | Date} end - A végdátum.
 * @param {boolean} [isMinusValid=false] - Lehet negatív szám is?
 * @returns {number} A két dátum közötti napok száma.
 */
module.exports.getDaysCountBetweenDates = function getDaysCountBetweenDates (start, end, isMinusValid = false) {
  const date1 = getDateInstance(start)
  const date2 = getDateInstance(end)

  const rawDiff = (date1.getTime() - date2.getTime())
  const diff    = isMinusValid ? rawDiff : Math.abs(rawDiff)
  const count   = Math.round(diff / consts.DAY_IN_MS)

  return count
}
